import ApiService from '../../../core/services/ApiService';

export interface PartnershipSettingData {
  id: string;
  partnershipId: string;
  taxYear: string;
  fixedAssetModuleEnabled: boolean;
  calculationProcessingMode: 'CalcEngine' | 'External';
  guaranteedPaymentsEnabled: boolean;
  taxYearEnd: string | null;
}

class PartnershipSettingsService extends ApiService {
  getSettings(partnershipId: string, taxYear: string): Promise<PartnershipSettingData> {
    return this.makeRequest<PartnershipSettingData>(
      `/api/partnership-settings/${partnershipId}?taxYear=${taxYear}`,
      { extractData: true },
    );
  }

  updateSettings(
    partnershipId: string,
    taxYear: string,
    data: Partial<PartnershipSettingData>,
  ): Promise<PartnershipSettingData> {
    return this.makeRequest<PartnershipSettingData>(
      `/api/partnership-settings/${partnershipId}?taxYear=${taxYear}`,
      { method: 'put', data: data as unknown as Record<string, unknown>, extractData: true },
    );
  }
}

export const partnershipSettingsService = new PartnershipSettingsService();
